<template>
  <div>
    <el-breadcrumb separator="/" style="margin-bottom: 20px;">
      <el-breadcrumb-item el-breadcrumb-item :to="{ path: '/project/batch' }">项目奖申报批次</el-breadcrumb-item>
      <el-breadcrumb-item el-breadcrumb-item :to="{ path: '/project?batchId=' +  $route.query.batchId }">项目奖申报</el-breadcrumb-item>
      <!-- <el-breadcrumb-item>{{ type == 2 ? '形式审查' : '形式受理'}}</el-breadcrumb-item> -->
      <el-breadcrumb-item>详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card v-loading="loading" >
      <!-- @tab-click="handleClick" -->
      <el-tabs v-model="activeName" >
        <el-tab-pane label="获奖情况" name="fourth" v-if="(awardsLv || confirm != null || awardsLv === 0)" class="second-2">
          <el-descriptions title="获奖信息" :column="1" border >
            <el-descriptions-item label-class-name="descriptions-label" label="项目名称">
              {{declareVo.projectName}}
              <span style="color: #165DFF;" v-if="confirm && confirm.isConfirm == 1">{{ confirm.code ? '(' + confirm.code + ')' : '(--)' }}</span>
            </el-descriptions-item>
            <el-descriptions-item label-class-name="descriptions-label" label="获奖情况">
              <span v-if="awardsLv === 0">特等奖</span>
              <span v-if="awardsLv == 1">一等奖</span>
              <span v-if="awardsLv == 2">二等奖</span>
              <span v-if="awardsLv == 3">三等奖</span>
            </el-descriptions-item>
            <el-descriptions-item label-class-name="descriptions-label" label="研究报告摘要">
              <span>{{declareVo.isResearBg || '--'}}</span>
            </el-descriptions-item>
            <el-descriptions-item label-class-name="descriptions-label" label="是否公开研究报告摘要">
              <span v-if="confirm == null">--</span>
              <span v-else-if="confirm.isConfirm == 2">否</span>
              <span v-else>
                <span v-if="confirm.isOpenGen == 1">是</span>
                <span v-if="confirm.isOpenGen == 2">否</span>
              </span>
            </el-descriptions-item>
            <el-descriptions-item label="是否授奖">
              <span v-if="confirm == null">--</span>
              <span v-else>
                <span v-if="confirm.isConfirm == 1">是</span>
                <span v-if="confirm.isConfirm == 2">否</span>
              </span>
            </el-descriptions-item>
            <template v-if="confirm && confirm.isConfirm == 1">
              <el-descriptions-item label="完成单位信息">
                <span style="word-break: break-all;">
                  <span v-for="(item, index) in confirm.unitList" :key="index">
                    {{ item.unit }}
                    <span style="color: #165DFF;">{{ item.code ? '(' + item.code + ')' : '(--)' }}</span>
                    {{index != confirm.unitList.length - 1 ? '、': ''}}
                  </span>
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="完成人信息" label-class-name="descriptions-label-table" class-name="descriptions-content-table">
                <div :style="{position: 'relative', height: MyTable1Height + 'px'}">
                  <div ref="MyTable1" style="position: absolute; width: 100%">
                    <el-table
                    style="width: 100%"
                    stripe
                    border
                    highlight-current-row
                    class="table tables"
                    :data="confirm.qtList"
                    scrollbar-always-on
                    header-cell-class-name="header-cell"
                    header-row-class-name="header-row">
                      <!-- <el-table-column label="序号" type="index" width="50"></el-table-column> -->
                      <el-table-column label="姓名" prop="name" width="80">
                        <template #default="scope">{{ scope.row.name || '--' }}</template>
                      </el-table-column>
                      <el-table-column label="联系方式" prop="phone" width="120">
                        <template #default="scope">{{ scope.row.phone || '--' }}</template>
                      </el-table-column>
                      <el-table-column label="邮箱" prop="email" width="">
                        <template #default="scope">{{ scope.row.email || '--' }}</template>
                      </el-table-column>
                      <el-table-column label="身份证" prop="identity" width="">
                        <template #default="scope">{{ scope.row.identity || '--' }}</template>
                      </el-table-column>
                      <el-table-column label="单位" prop="unit" width="">
                        <template #default="scope">{{ scope.row.unit || '--' }}</template>
                      </el-table-column>
                      <el-table-column label="职位" prop="job" width="120">
                        <template #default="scope">{{ scope.row.job || '--' }}</template>
                      </el-table-column>
                      <el-table-column label="职称" prop="named" width="120">
                        <template #default="scope">{{ scope.row.named || '--' }}</template>
                      </el-table-column>
                      <el-table-column label="毕业院校" prop="graduate" width="">
                        <template #default="scope">{{ scope.row.graduate || '--' }}</template>
                      </el-table-column>
                      <el-table-column label="证书编号" prop="code" >
                        <template #default="scope">{{ scope.row.code || '--' }}</template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </el-descriptions-item>
            </template>
            <template v-if="confirm && confirm.isConfirm == 2">
              <el-descriptions-item label="放弃奖励证明">
                <el-link type="primary" @click="handleUploadAward(confirm.rejectAwardFileUrl)">点击下载</el-link>
                <!-- <el-link type="primary" @click="handleUploadFinal(confirm.rejectAwardFile.path, confirm.rejectAwardFile.remark)">点击下载</el-link> -->
                <!-- <span v-if="confirm.rejectAwardFile">{{ confirm.rejectAwardFile.remark }}</span> -->
                <!-- <el-link type="primary" @click="handleUploadAward(confirm.rejectAwardFileUrl)">点击下载</el-link> -->
              </el-descriptions-item>
            </template>
          </el-descriptions>
        </el-tab-pane>
        <el-tab-pane label="终审补充材料" name="third" v-if="zsCheckVo" class="second-2">
          <el-descriptions title="终审阶段上传的补充材料" :column="3" border >
            <el-descriptions-item label="项目答辩PPT" :span="3">
              <!-- <span v-if="detailVo.materialReportFiles">{{ detailVo.materialReportFiles[0].remark }}</span> -->
              <el-link v-if="detailVo.materialReportFiles" type="primary" @click="handleUploadFinal(detailVo.materialReportFiles[0].path, detailVo.materialReportFiles[0].remark)">点击下载</el-link>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="项目介绍的简本（包含项目背景、主要技术路线、创新点、社会经济效益等内容）" :span="3">
              <!-- <span v-if="detailVo.materialReportFiles">{{detailVo.materialReportFiles[1].remark}}</span> -->
              <el-link v-if="detailVo.materialReportFiles" type="primary" @click="handleUploadFinal(detailVo.materialReportFiles[1].path, detailVo.materialReportFiles[1].remark)">点击下载</el-link>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="答辩单位" :span="3">
              <span v-if="detailVo.reply">{{ detailVo.reply.replyUnit }}</span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="答辩项目" :span="3">
              <span v-if="detailVo.reply">{{ detailVo.reply.replyName }}</span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="主答辩人" :span="1">
              <span v-if="detailVo.reply">{{ detailVo.reply.replyPerson1 }}</span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="职务" :span="1">
              <span v-if="detailVo.reply">{{ detailVo.reply.job1 }}</span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="电话" :span="1">
              <span v-if="detailVo.reply">{{ detailVo.reply.phone1 }}</span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="答辩人" :span="1">
              <span v-if="detailVo.reply">{{ detailVo.reply.replyPerson2 }}</span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="职务" :span="1">
              <span v-if="detailVo.reply">{{ detailVo.reply.job2 }}</span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="电话" :span="1">
              <span v-if="detailVo.reply">{{ detailVo.reply.phone2 }}</span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="答辩人" :span="1">
              <span v-if="detailVo.reply">{{ detailVo.reply.replyPerson3 }}</span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="职务" :span="1">
              <span v-if="detailVo.reply">{{ detailVo.reply.job3 }}</span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="电话" :span="1">
              <span v-if="detailVo.reply">{{ detailVo.reply.phone3 }}</span>
              <span v-else>--</span>
            </el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>
        <el-tab-pane label="形式审查结果" name="second" v-if="declareVo.logVos && declareVo.logVos.length > 0" class="second-2">
          <el-descriptions title="形式审查信息" :column="4" border style="margin-bottom: 20px;" >
            <template v-for="(item, index) in declareVo.logVos" >
              <el-descriptions-item :key="index" label="审查状态" :span="1">{{item.logContent}}</el-descriptions-item>
              <el-descriptions-item :key="index" label="审查时间" :span="1">{{item.logTime}}</el-descriptions-item>
              <el-descriptions-item :key="index" label="审查意见" :span="2">
                {{item.opinion || '--'}}
              </el-descriptions-item>
            </template>
          </el-descriptions>
          <el-descriptions title="上传的盖章版材料" :column="2" border style="margin-top: 20px" v-if="declareVo && declareVo.materialDeclareReportFiles">
            <el-descriptions-item :span="2" label="申报书全部内容（除项目成果研究报告）整合为一个PDF文件，加盖公章版本" >
              <!-- <span v-if="declareVo && declareVo.materialDeclareReportFiles">{{declareVo.materialDeclareReportFiles[0].remark}}</span> -->
              <el-link v-if="declareVo && declareVo.materialDeclareReportFiles" type="primary" @click="handleUploadFinal(declareVo.materialDeclareReportFiles[0].path, declareVo.materialDeclareReportFiles[0].remark)">点击下载</el-link>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item :span="2" label="项目成果研究报告" >
              <!-- <span v-if="declareVo && declareVo.materialDeclareReportFiles">{{declareVo.materialDeclareReportFiles[1].remark}}</span> -->
              <el-link v-if="declareVo && declareVo.materialDeclareReportFiles" type="primary" @click="handleUploadFinal(declareVo.materialDeclareReportFiles[1].path, declareVo.materialDeclareReportFiles[1].remark)">点击下载</el-link>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item :span="2" label="第一完成单位名称">
              <span v-if="declareVo.unitVos && declareVo.unitVos.length > 0">{{declareVo.unitVos[0].otherUnit}}</span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item :span="2" label="其他完成单位">
              <span v-if="declareVo.unitVos && declareVo.unitVos.length > 1">
                <span v-for="(item, index) in declareVo.unitVos" :key="index">
                  <span v-if="index > 0">{{ item.otherUnit }}{{ index !=  declareVo.unitVos.length - 1 ? '、' : ''}}</span>
                </span>
              </span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item :span="2" label="第一完成人信息" >
              <span v-if="declareVo.personVos && declareVo.personVos.length > 0">
                {{ declareVo.personVos[0].otherThose + ' (' +  declareVo.personVos[0].completePhones +')' }}
              </span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item :span="2" label="第二完成人信息">
              <span v-if="declareVo.personVos && declareVo.personVos.length > 0">
                {{ declareVo.personVos[1].otherThose + ' (' +  declareVo.personVos[1].completePhones +')' }}
              </span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item :span="2" label="第三完成人信息">
              <span v-if="declareVo.personVos && declareVo.personVos.length > 0">
                {{ declareVo.personVos[2].otherThose + ' (' +  declareVo.personVos[2].completePhones +')' }}
              </span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item :span="2" label="其他完成人信息">
              <span v-if="declareVo.personVos && declareVo.personVos.length > 3">
                <span v-for="(item, index) in declareVo.personVos" :key="index">
                  <span v-if="index > 2">{{ item.otherThose + ' (' +  item.completePhones +')' }}{{ index !=  declareVo.personVos.length - 1 ? '、' : ''}}</span>
                </span>
              </span>
              <span v-else>--</span>
            </el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>
        <el-tab-pane label="申报信息" name="first" class="first-1">
          <div style="display: flex; align-items: center; margin-bottom: 15px;">
            <div style="font-size: 16px; color: #000; font-weight: 700; flex: 1">项目奖申报详情</div>
            <div v-if="status == 1">
              <!-- <el-button size="small" type="danger" v-if="declareVo.acceptExamineStatus == 4" @click="handleCh">撤回</el-button> -->
              <el-button size="small" type="warning" v-if="(declareVo.acceptExamineStatus == 5 || declareVo.isDraft == 2) && (projectState == 1 || declareVo.isDraft != 2)" @click="handleEdit">修改</el-button>
              <el-button size="small" type="warning" v-if="declareVo.isDraft == 2 && projectState == 1" @click="handleEdit">提交</el-button>
              <el-button size="small" type="primary" v-if="declareVo.acceptExamineStatus == 6 && declareVo.materialDeclareSupplementState == 1" @click="replenishs">上传材料</el-button>
              <el-button size="small" type="primary" v-if="declareVo.acceptExamineStatus == 6 && declareVo.materialDeclareSupplementState == 2" @click="ewm">下载二维码</el-button>
              <el-button size="small" type="warning" v-if="projectId && declareVo.materialFinallySupplementState == 1" @click="replenish">补充材料</el-button>
            </div>
          </div>
          <el-descriptions title="一、项目基本情况" :column="3" border style="margin-bottom: 20px;" class="first-1-1">
            <el-descriptions-item label="项目名称" :span="3">{{declareVo.projectName || '--'}}</el-descriptions-item>
            <el-descriptions-item label="所属专业领域" :span="3">
              <span v-if="declareVo.unitNature1 == 1">公路</span>
              <span v-else-if="declareVo.unitNature1 == 2">铁路</span>
              <span v-else-if="declareVo.unitNature1 == 3">水运</span>
              <span v-else-if="declareVo.unitNature1 == 4">航空</span>
              <span v-else-if="declareVo.unitNature1 == 5">市政</span>
              <span v-else-if="declareVo.unitNature1 == 6">综合交通</span>
              <span v-else-if="declareVo.unitNature1 == 8">邮政</span>
              <span v-else-if="declareVo.unitNature1 == 9">物流</span>
              <span v-else-if="declareVo.unitNature1 == 7">其他{{' (' + (declareVo.nature1Other || '--') + ')'}}</span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="第一完成单位" :span="2">{{declareVo.mainUnit || '--'}}</el-descriptions-item>
            <el-descriptions-item label="第一完成单位性质" :span="1">
              <span v-if="declareVo.unitNature2 == 1">设计咨询</span>
              <span v-else-if="declareVo.unitNature2 == 2">工程施工</span>
              <span v-else-if="declareVo.unitNature2 == 3">科研机构</span>
              <span v-else-if="declareVo.unitNature2 == 4">高等院校</span>
              <span v-else-if="declareVo.unitNature2 == 5">企事业单位</span>
              <span v-else-if="declareVo.unitNature2 == 6">项目业主单位</span>
              <span v-else-if="declareVo.unitNature2 == 7">其他社会组织</span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="其他完成单位信息" :span="3" v-if="declareVo.otherUnit && declareVo.otherUnit.length > 0">
              <el-link type="primary" :underline="false" @click="dialogShow('其他完成单位信息', declareVo.otherUnit, 'otherUnit')">详情</el-link>
            </el-descriptions-item>
            <!-- <template v-for="(item, index) in declareVo.otherUnit" >
              <el-descriptions-item :key="index" :span="1" label="其他完成单位">{{item.otherUnit || '--'}}</el-descriptions-item>
              <el-descriptions-item :key="item.index" :span="2" label="其他完成单位性质">
                <span v-if="item.unitNature2 == 1">设计咨询</span>
                <span v-if="item.unitNature2 == 2">工程施工</span>
                <span v-if="item.unitNature2 == 3">科研机构</span>
                <span v-if="item.unitNature2 == 4">高等院校</span>
                <span v-if="item.unitNature2 == 5">企事业单位</span>
                <span v-if="item.unitNature2 == 6">项目业主单位</span>
                <span v-if="item.unitNature2 == 7">其他社会组织</span>
                <span v-if="!item.unitNature2">--</span>
              </el-descriptions-item>
            </template> -->
            <el-descriptions-item :span="1" label="第一完成人姓名">{{declareVo.mainThose || '--'}}</el-descriptions-item>
            <el-descriptions-item :span="1" label="第一完成人联系方式">{{declareVo.thosePhone || '--'}}</el-descriptions-item>
            <el-descriptions-item :span="1" label="第一完成人邮箱">{{declareVo.email1 || '--'}}</el-descriptions-item>
            <el-descriptions-item :span="1" label="第二完成人姓名">{{declareVo.mainThose2 || '--'}}</el-descriptions-item>
            <el-descriptions-item :span="1" label="第二完成人联系方式">{{declareVo.thosePhone2 || '--'}}</el-descriptions-item>
            <el-descriptions-item :span="1" label="第二完成人邮箱">{{declareVo.email2 || '--'}}</el-descriptions-item>
            <el-descriptions-item :span="1" label="第三完成人姓名">{{declareVo.mainThose3 || '--'}}</el-descriptions-item>
            <el-descriptions-item :span="1" label="第三完成人联系方式">{{declareVo.thosePhone3 || '--'}}</el-descriptions-item>
            <el-descriptions-item :span="1" label="第三完成人邮箱">{{declareVo.email3 || '--'}}</el-descriptions-item>
            <!-- <el-descriptions-item :span="1" label="第三完成人信息">{{declareVo.mainThose3 || '--'}} {{ declareVo.thosePhone3 ? ' (' + declareVo.thosePhone3 + ')' : '(--)'}}</el-descriptions-item> -->
            <el-descriptions-item :span="3" label="其他完成人信息" v-if="declareVo.qtList && declareVo.qtList.length > 0">
              <el-link type="primary" :underline="false" @click="dialogShow('其他完成人信息', declareVo.qtList, 'qtList')">详情</el-link>
              <!-- <span >
                <span v-for="(item, index) in declareVo.qtList" :key="index">
                  <span>{{ item.name || '-- ' }}{{ item.phone ? ' (' + item.phone + ')' : ' (--)' }}{{index != declareVo.qtList.length - 1 ? '、': ''}}</span>
                </span>
              </span>
              <span v-else>--</span> -->
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions title="二、第三方评价情况" :column="2" border style="margin-bottom: 20px;">
            <el-descriptions-item label="第三方科技成果评价结论" :span="1">
              <el-link type="primary" :underline="false" @click="dialogShow('第三方科技成果评价结论', declareVo.authConclusions, 1)">详情</el-link>
            </el-descriptions-item>
            <el-descriptions-item label="科技查新结论" :span="1">
              <span v-if="declareVo.orgOption">
                <div v-if="declareVo.newConclusions">
                  <!-- <span style="vertical-align: middle;">有</span> -->
                  <el-link type="primary" :underline="false" @click="dialogShow('科技查新结论', declareVo.newConclusions, 2)">详情</el-link>
                </div>
                <span v-else>无</span>
              </span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="第三方检测结论" :span="1">
              <span v-if="declareVo.levelOrOpinion">
                <div v-if="declareVo.detectionConclusions">
                  <el-link type="primary" :underline="false" @click="dialogShow('第三方检测结论', declareVo.detectionConclusions, 3)">详情</el-link>
                </div>
                <span v-else>无</span>
              </span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="国内外同行在重要学术刊物" :span="1">
              <span v-if="declareVo.isOwnPatent">
                <div v-if="declareVo.academicOpinions">
                  <el-link type="primary" :underline="false" @click="dialogShow('国内外同行在重要学术刊物', declareVo.academicOpinions, 4)">详情</el-link>
                </div>
                <span v-else>无</span>
              </span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="具有影响力的新闻媒体评价" :span="1">
              <span v-if="declareVo.isOwnNewpatent">
                <div v-if="declareVo.mediaEvaluations">
                  <el-link type="primary" :underline="false" @click="dialogShow('新闻媒体评价', declareVo.mediaEvaluations, 5)">详情</el-link>
                </div>
                <span v-else>无</span>
              </span>
              <span v-else>--</span>
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions title="三、应用推广情况" :column="2" border style="margin-bottom: 20px;" class="dan">
            <el-descriptions-item label="应用推广情况" :span="1">
              <span v-if="declareVo.isOwnSoftware">
                <div v-if="declareVo.appExtends">
                  <el-link type="primary" :underline="false" @click="dialogShow('应用推广情况', declareVo.appExtends, 6)">详情</el-link>
                </div>
                <span v-else>无</span>
              </span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="" :span="1" ></el-descriptions-item>
          </el-descriptions>
          <el-descriptions title="四、曾获科技奖励情况" :column="2" border style="margin-bottom: 20px;" class="dan">
            <el-descriptions-item label="曾获科技奖励情况" :span="1">
              <span v-if="declareVo.isOwnMethod">
                <div v-if="declareVo.historyRewards">
                  <el-link type="primary" :underline="false" @click="dialogShow('曾获科技奖励情况', declareVo.historyRewards, 7)">详情</el-link>
                </div>
                <span v-else>无</span>
              </span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="" :span="1" ></el-descriptions-item>
          </el-descriptions>
          <el-descriptions title="五、主要知识产权目录情况" :column="2" border style="margin-bottom: 20px;" class="dan">
            <el-descriptions-item label="主要知识产权" :span="1">
              <span v-if="declareVo.isOwnThesis">
                <div v-if="declareVo.intellectualProperties">
                  <el-link type="primary" :underline="false" @click="dialogShow('主要知识产权', declareVo.intellectualProperties, 8)">详情</el-link>
                </div>
                <span v-else>无</span>
              </span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="" :span="1" ></el-descriptions-item>
          </el-descriptions>
          <el-descriptions title="六、主持或参与制定的标准情况" :column="2" border style="margin-bottom: 20px;" class="dan">
            <el-descriptions-item label="主持或参与制定的标准" :span="1">
              <span v-if="declareVo.isOwnTreatise">
                <div v-if="declareVo.formulateStandards">
                  <el-link type="primary" :underline="false" @click="dialogShow('制定的标准', declareVo.formulateStandards, 9)">详情</el-link>
                </div>
                <span v-else>无</span>
              </span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="" :span="1" ></el-descriptions-item>
          </el-descriptions>
          <el-descriptions title="七、代表性论文/专著发表情况" :column="2" border style="margin-bottom: 20px;" class="dan">
            <el-descriptions-item label="代表性论文/专著发表情况" :span="1">
              <span v-if="declareVo.isOwnAward">
                <div v-if="declareVo.monographs">
                  <el-link type="primary" :underline="false" @click="dialogShow('代表性论文/专著发表情况', declareVo.monographs, 10)">详情</el-link>
                </div>
                <span v-else>无</span>
              </span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="" :span="1" ></el-descriptions-item>
          </el-descriptions>
          <el-descriptions title="八、项目来源情况" :column="2" border style="margin-bottom: 20px;">
            <el-descriptions-item label="项目来源" :span="2">{{declareVo.projectSource || '--'}}</el-descriptions-item>
            <el-descriptions-item label="领导人圈阅批示次数">{{declareVo.viewedTimes == null ? '--' : declareVo.viewedTimes}}</el-descriptions-item>
            <el-descriptions-item label="有关政策文件制定被采用次数">{{declareVo.policyUseTimes == null ? '--' : declareVo.policyUseTimes}}</el-descriptions-item>
          </el-descriptions>
          <el-descriptions title="九、项目数据" :column="2" border style="margin-bottom: 20px;">
            <el-descriptions-item label="工程应用数(个)" :span="1">{{declareVo.proveUnitNumber == null ? '--' : declareVo.proveUnitNumber}}</el-descriptions-item>
            <el-descriptions-item label="专利发明数(个)" :span="1">{{declareVo.patentNumber == null ? '--' : declareVo.patentNumber}}</el-descriptions-item>
            <el-descriptions-item label="实用专利数(个)" :span="1">{{declareVo.newPatentNumber == null ? '--' : declareVo.newPatentNumber}}</el-descriptions-item>
            <el-descriptions-item label="软件著作权数(个)" :span="1">{{declareVo.softwareCopyrightNumber == null ? '--' : declareVo.softwareCopyrightNumber}}</el-descriptions-item>
            <el-descriptions-item label="论文数(个)" :span="1">{{declareVo.thesisNumber == null ? '--' : declareVo.thesisNumber}}</el-descriptions-item>
            <el-descriptions-item label="SCI(篇)" :span="1">{{declareVo.sciNumber == null ? '--' : declareVo.sciNumber}}</el-descriptions-item>
            <el-descriptions-item label="SSCI(篇)" :span="1">{{declareVo.ssciNumber == null ? '--' : declareVo.ssciNumber}}</el-descriptions-item>
            <el-descriptions-item label="CSSCI(篇)" :span="1">{{declareVo.cssciNumber == null ? '--' : declareVo.cssciNumber}}</el-descriptions-item>
            <el-descriptions-item label="ei(篇)" :span="1">{{declareVo.eiNumber == null ? '--' : declareVo.eiNumber}}</el-descriptions-item>
            <el-descriptions-item label="著作数(个)" :span="1">{{declareVo.methodNumber == null ? '--' : declareVo.methodNumber}}</el-descriptions-item>
            <el-descriptions-item label="获奖数(个)" :span="1">{{declareVo.awardNumber == null ? '--' : declareVo.awardNumber}}</el-descriptions-item>
            <el-descriptions-item label="研究报告摘要" :span="1">
              {{declareVo.isResearBg || '--'}}
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions title="十、附件上传" :column="2" border>
            <el-descriptions-item label="申报书">
              <!-- <span v-for="(item, index) in declareVo.declarationFiles" :key="index">{{item.remark}}</span> -->
              <el-link type="primary" v-for="(item, index) in declareVo.declarationFiles" :key="index" @click="handleUploadFinal(item.path, item.remark)">点击下载</el-link>
              <span v-if="!declareVo.declarationFiles">--</span>
            </el-descriptions-item>
            <el-descriptions-item label="第三方评价">
              <!-- <span v-for="(item, index) in declareVo.evaluationFiles" :key="index">{{item.remark}}</span> -->
              <el-link type="primary" v-for="(item, index) in declareVo.evaluationFiles" :key="index" @click="handleUploadFinal(item.path, item.remark)">点击下载</el-link>
              <span v-if="!declareVo.evaluationFiles">--</span>
            </el-descriptions-item>
            <el-descriptions-item label="应用推广相关证明">
              <!-- <span v-for="(item, index) in declareVo.extensionCertificateFiles" :key="index">{{item.remark}}</span> -->
              <el-link type="primary" v-for="(item, index) in declareVo.extensionCertificateFiles" :key="index" @click="handleUploadFinal(item.path, item.remark)">点击下载</el-link>
              <span v-if="!declareVo.extensionCertificateFiles">--</span>
            </el-descriptions-item>
            <el-descriptions-item label="本项目曾获科技奖励相关证明">
              <!-- <span v-for="(item, index) in declareVo.historyRewardsFiles" :key="index">{{item.remark}}</span> -->
              <el-link type="primary" v-for="(item, index) in declareVo.historyRewardsFiles" :key="index" @click="handleUploadFinal(item.path, item.remark)">点击下载</el-link>
              <span v-if="!declareVo.historyRewardsFiles">--</span>
            </el-descriptions-item>
            <el-descriptions-item label="知识产权证明">
              <!-- <span v-for="(item, index) in declareVo.titleCertificateFiles" :key="index">{{item.remark}}</span> -->
              <el-link type="primary" v-for="(item, index) in declareVo.titleCertificateFiles" :key="index" @click="handleUploadFinal(item.path, item.remark)">点击下载</el-link>
              <span v-if="!declareVo.titleCertificateFiles">--</span>
            </el-descriptions-item>
            <el-descriptions-item label="研究报告">
              <!-- <span v-for="(item, index) in declareVo.researchReportFiles" :key="index">{{item.remark}}</span> -->
              <el-link type="primary" v-for="(item, index) in declareVo.researchReportFiles" :key="index" @click="handleUploadFinal(item.path, item.remark)">点击下载</el-link>
              <span v-if="!declareVo.researchReportFiles">--</span>
            </el-descriptions-item>
            <el-descriptions-item label="软课题项目:项目来源、社会效益、项目是否被有关领导签阅或被政府有关部门实际应用">
              <!-- <span v-for="(item, index) in declareVo.softProjectFiles" :key="index">{{item.remark}}</span> -->
              <el-link type="primary" v-for="(item, index) in declareVo.softProjectFiles" :key="index" @click="handleUploadFinal(item.path, item.remark)">点击下载</el-link>
              <span v-if="!declareVo.softProjectFiles">--</span>
            </el-descriptions-item>
            <el-descriptions-item label="其他证明等">
              <!-- <span v-for="(item, index) in declareVo.otherProofFiles" :key="index">{{item.remark}}</span> -->
              <el-link type="primary" v-for="(item, index) in declareVo.otherProofFiles" :key="index" @click="handleUploadFinal(item.path, item.remark)">点击下载</el-link>
              <span v-if="!declareVo.otherProofFiles">--</span>
            </el-descriptions-item>
            <el-descriptions-item label="主持或参与制定的标准文件">
              <!-- <span v-for="(item, index) in declareVo.presideFiles" :key="index">{{item.remark}}</span> -->
              <el-link type="primary" v-for="(item, index) in declareVo.presideFiles" :key="index" @click="handleUploadFinal(item.path, item.remark)">点击下载</el-link>
              <span v-if="!declareVo.presideFiles">--</span>
            </el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <el-dialog :title="dialog.title" :visible.sync="dialog.dialogVisible" :modal-append-to-body='false' :close-on-click-modal="false" @close="close">
      <el-table :data="dialog.list" stripe highlight-current-row border :header-cell-style="{background: '#f5f7fa', color: '#333'}" >
        <el-table-column label="序号" type="index" width="55"></el-table-column>
        <template v-if="dialog.type == 'otherUnit'" >
          <el-table-column prop="otherUnit" label="其他完成单位" ></el-table-column>
          <el-table-column prop="unitNature2" label="其他完成单位性质" >
            <template slot-scope="scope">
              <span v-if="scope.row.unitNature2 == 1">设计咨询</span>
              <span v-else-if="scope.row.unitNature2 == 2">工程施工</span>
              <span v-else-if="scope.row.unitNature2 == 3">科研机构</span>
              <span v-else-if="scope.row.unitNature2 == 4">高等院校</span>
              <span v-else-if="scope.row.unitNature2 == 5">企事业单位</span>
              <span v-else-if="scope.row.unitNature2 == 6">项目业主单位</span>
              <span v-else-if="scope.row.unitNature2 == 7">其他社会组织</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
        </template>
        <template v-if="dialog.type == 'qtList'" >
          <el-table-column prop="name" label="其他完成人姓名" ></el-table-column>
          <el-table-column prop="phone" label="其他完成人联系方式" ></el-table-column>
          <el-table-column prop="email" label="其他完成人邮箱" ></el-table-column>
        </template>
        <template v-if="dialog.type == 1" >
          <el-table-column prop="orgName" label="评价机构" ></el-table-column>
          <el-table-column prop="time" label="评价日期" ></el-table-column>
          <el-table-column prop="registerNo" label="评价登记号" ></el-table-column>
          <el-table-column prop="conclusion" label="评价结论" ></el-table-column>
        </template>
        <template v-if="dialog.type == 2">
          <el-table-column prop="orgName" label="查新机构" ></el-table-column>
          <el-table-column prop="time" label="查新日期" ></el-table-column>
          <el-table-column prop="conclusion" label="查新结论" ></el-table-column>
        </template>
        <template v-if="dialog.type == 3">
          <el-table-column prop="orgName" label="检测机构" ></el-table-column>
          <el-table-column prop="time" label="检测日期" ></el-table-column>
          <el-table-column prop="conclusion" label="检测结论" ></el-table-column>
        </template>
        <template v-if="dialog.type == 4">
          <el-table-column prop="name" label="刊物/专著/会议名称" ></el-table-column>
          <el-table-column prop="time" label="发表/出版/举办年月" ></el-table-column>
          <el-table-column prop="opinion" label="评价意见" ></el-table-column>
        </template>
        <template v-if="dialog.type == 5">
          <el-table-column prop="mediaName" label="媒体名称" ></el-table-column>
          <el-table-column prop="publishTime" label="出版日期" ></el-table-column>
          <el-table-column prop="layout" label="版面" ></el-table-column>
          <el-table-column prop="evaluation" label="评价意见" ></el-table-column>
        </template>
        <template v-if="dialog.type == 6">
          <el-table-column prop="unitOrgName" label="单位机构" ></el-table-column>
          <el-table-column prop="appStartTime" label="应用起始时间" ></el-table-column>
          <el-table-column prop="contactPersonName" label="联系人" ></el-table-column>
          <el-table-column prop="contactPersonPhone" label="联系电话" ></el-table-column>
        </template>
        <template v-if="dialog.type == 7">
          <el-table-column prop="time" label="获奖时间" ></el-table-column>
          <el-table-column prop="name" label="奖项名称" ></el-table-column>
          <el-table-column prop="lv" label="奖励等级" ></el-table-column>
          <el-table-column prop="section" label="授奖部门（机构）" ></el-table-column>
          <el-table-column prop="completionUnit" label="主要完成单位" ></el-table-column>
          <el-table-column prop="people" label="主要获奖人" ></el-table-column>
        </template>
        <template v-if="dialog.type == 8">
          <el-table-column prop="type" label="知识产权类别" ></el-table-column>
          <el-table-column prop="name" label="知识产权名称" ></el-table-column>
          <el-table-column prop="nation" label="国家（地区）" ></el-table-column>
          <el-table-column prop="accreditNo" label="授权号" ></el-table-column>
          <el-table-column prop="accreditTime" label="授权日期" ></el-table-column>
          <el-table-column prop="certificateNo" label="证书编号" ></el-table-column>
          <el-table-column prop="obligeeFirstPlace" label="权利人1" ></el-table-column>
          <el-table-column prop="obligeeRunnerUp" label="权利人2" ></el-table-column>
          <el-table-column prop="obligeeThirdPlace" label="权利人3" ></el-table-column>
          <el-table-column prop="inventorFirstPlace" label="发明人1" ></el-table-column>
          <el-table-column prop="inventorRunnerUp" label="发明人2" ></el-table-column>
          <el-table-column prop="inventorThirdPlace" label="发明人3" ></el-table-column>
        </template>
        <template v-if="dialog.type == 9">
          <el-table-column prop="type" label="标准类型" ></el-table-column>
          <el-table-column prop="name" label="标准名称" ></el-table-column>
          <el-table-column prop="no" label="标准号" ></el-table-column>
          <el-table-column prop="publishTime" label="发布时间" ></el-table-column>
          <el-table-column prop="publishOrgName" label="发布机关" ></el-table-column>
        </template>
        <template v-if="dialog.type == 10">
          <el-table-column prop="name" label="论文/专著名称" ></el-table-column>
          <el-table-column prop="publishingHouse" label="刊名/出版社" ></el-table-column>
          <el-table-column prop="publishTime" label="发表/出版年月" ></el-table-column>
          <el-table-column prop="location" label="年（卷）：页码" ></el-table-column>
          <el-table-column prop="authorFirstPlace" label="作者1" ></el-table-column>
          <el-table-column prop="authorRunnerUp" label="作者2" ></el-table-column>
          <el-table-column prop="authorThirdPlace" label="作者3" ></el-table-column>
        </template>
      </el-table>
    </el-dialog>

    <!-- 审查通过上传材料 -->
    <el-dialog class="dia" title="上传材料" :visible.sync="materials.dialogVisible" :modal-append-to-body='false' :close-on-click-modal="false" @close="closeMaterials">
      <el-form :model="materials" :rules="ruleAddForm" ref="materials" label-position="top" label-width="120px" class="demo-ruleForm">
        <el-form-item label="" prop="projectExcelPath" >
          <span slot="label">
            <span>请提交最终确定版的主要完成单位和主要完成人（限excel文件）</span>
            <el-link type="primary" :underline="false" style="margin-top: -4px;" @click="download(7)">下载模板</el-link>
          </span>
          <el-checkbox-group v-model="materials.projectExcelPath" v-show="false"></el-checkbox-group>
          <My-Upload-Filebutton :limit="1" :accept="'.xls,.xlsx'" @UploadFileFun="UploadFileFuns($event, 'projectExcelPath')" :callbackShow="materials.projectExcelFiles" />
        </el-form-item>
        <el-form-item label="请将申报书全部内容（除项目成果研究报告）整合为一个pdf文件，加盖公章后在此上传（限pdf格式）" prop="declarePdfPath" >
          <el-checkbox-group v-model="materials.declarePdfPath" v-show="false"></el-checkbox-group>
          <My-Upload-Filebutton :limit="1" :accept="'.pdf'" @UploadFileFun="UploadFileFuns($event, 'declarePdfPath')" :callbackShow="materials.declarePdfFiles" />
        </el-form-item>
        <el-form-item label="请提交项目成果研究报告(限pdf格式)" prop="projectResultsPath" >
          <el-checkbox-group v-model="materials.projectResultsPath" v-show="false"></el-checkbox-group>
          <My-Upload-Filebutton :limit="1" :accept="'.pdf'" @UploadFileFun="UploadFileFuns($event, 'projectResultsPath')" :callbackShow="materials.projectResultsFiles" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="materials.dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="materials.loading" @click="submitAdds" >确 定</el-button>
      </span>
    </el-dialog>
    <!-- 进入终审材料补充 -->
    <el-dialog class="dia" title="材料补充" :visible.sync="addForm.dialogVisible" :modal-append-to-body='false' :close-on-click-modal="false" @close="closeAddForm">
      <el-form :model="addForm" :rules="ruleAddForm" ref="addForm" label-position="top" label-width="120px" class="demo-ruleForm">
        <el-form-item label="" prop="projectExcelPath" >
          <span slot="label">
            <span>项目答辩PPT（限PPT格式）</span>
          </span>
          <el-checkbox-group v-model="addForm.projectExcelPath" v-show="false"></el-checkbox-group>
          <My-Upload-Filebutton :limit="1" :accept="'.ppt,.pptx'" @UploadFileFun="UploadFileFun($event, 'projectExcelPath')" :callbackShow="addForm.projectExcelFiles" />
        </el-form-item>
        <el-form-item label="项目介绍的简本（包含项目背景、主要技术路线、创新点、社会经济效益等内容，不超过20页）" prop="declarePdfPath" >
          <el-checkbox-group v-model="addForm.declarePdfPath" v-show="false"></el-checkbox-group>
          <My-Upload-Filebutton :limit="1" @UploadFileFun="UploadFileFun($event, 'declarePdfPath')" :callbackShow="addForm.declarePdfFiles" />
        </el-form-item>
        <el-form-item label="" prop="projectResultsPath" >
          <span slot="label">
            <span>终审答辩人员信息表（限excel文件）</span>
            <el-link type="primary" :underline="false" style="margin-top: -4px;" @click="download(9)">下载模板</el-link>
          </span>
          <el-checkbox-group v-model="addForm.projectResultsPath" v-show="false"></el-checkbox-group>
          <My-Upload-Filebutton :limit="1" :accept="'.xls,.xlsx'" @UploadFileFun="UploadFileFun($event, 'projectResultsPath')" :callbackShow="addForm.projectResultsFiles" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addForm.dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="addForm.loading" @click="submitAdd" >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MyUploadFilebutton from '@/components/uploadFilebutton/UploadFilebutton'
import { getStProjectAward, addStProjectAwardThree, getQrcodeCheckProject, getStProjectEwm, getProjectAwardBatchList, getMangerStatus } from '@/api/admin'
import { uploadFileDownload, AdminDownLoadFile } from '@/api/system'
// increasedGetWebFiles,
import { increasedGetWebFiles, increasedProjectWithdraw } from '@/api/increased'

// import { AdminDownLoadFile } from '@/api/system'

export default {
  components: { MyUploadFilebutton },
  data () {
    return {
      projectState: '', // 添加状态
      activeName: 'first',
      status: '',
      projectId: '',
      loading: false,
      info: {},
      type: '',
      dialog: {
        type: '',
        title: '',
        dialogVisible: false,
        list: []
      },
      // 材料补充
      addForm: {
        dialogVisible: false,
        loading: false,
        opinion: '',
        projectId: '',
        id: '',
        projectExcelPath: '',
        declarePdfPath: '',
        projectResultsPath: ''
      },
      // 上传材料
      materials: {
        dialogVisible: false,
        loading: false,
        opinion: '',
        projectId: '',
        id: '',
        projectExcelPath: '',
        declarePdfPath: '',
        projectResultsPath: ''
      },
      ruleAddForm: {
        projectExcelPath: [{ required: true, message: '请上传文件', trigger: 'change' }],
        declarePdfPath: [{ required: true, message: '请上传文件', trigger: 'change' }],
        projectResultsPath: [{ required: true, message: '请上传文件', trigger: 'change' }]
      },
      fileList: {},
      declareVo: {},
      detailVo: {},
      zsCheckVo: {},
      awardsLv: '',
      confirm: {},
      MyTable1Height: 0
    }
  },
  created () {
    this.projectId = this.$route.query.projectId || ''
    if (!this.$route.query.batchId) {
      this.$router.push({ path: '/project/batch' })
      return false
    }
    // this.type = this.$route.query.type
    if (!this.$route.query.id) {
      this.$router.push({ path: '/project', query: { batchId: this.$route.query.batchId } })
      return false
    }

    getProjectAwardBatchList({ page: 1, pageSize: 500 }).then(res => {
      if (res.code == '000') {
        const batchIds = res.result.records
        const exists = batchIds.some(item => item.id === this.$route.query.batchId)
        if (!exists) {
          this.$router.push({ path: '/project/batch' })
        } else {
          batchIds.forEach(item => {
            if (item.id == this.$route.query.batchId) {
              this.status = item.status
            }
          })
        }
      }
    })
    this.getDetails()
    this.getStatus()
    // 获取文件
    increasedGetWebFiles({}).then(res => {
      if (res.code == '000') {
        this.fileList = res.result
      }
    })
  },
  mounted () {
    window.addEventListener('resize', () => {
      if (this.$refs.MyTable1) {
        this.MyTable1Height = this.$refs.MyTable1.offsetHeight
      }
    })
  },
  methods: {
    // 上传形审材料
    UploadFileFuns(e, type) {
      this.materials[type] = e
    },
    // 上传终审材料
    UploadFileFun(e, type) {
      this.addForm[type] = e
    },
    alignArrays (arr1, arr2, arr3) {
      const maxLength = Math.max(arr1.length, arr2.length, arr3.length)
      if (arr1.length < maxLength) {
        arr1.push(...new Array(maxLength - arr1.length).fill(''))
      }
      if (arr2.length < maxLength) {
        arr2.push(...new Array(maxLength - arr2.length).fill(''))
      }
      if (arr3.length < maxLength) {
        arr3.push(...new Array(maxLength - arr3.length).fill(''))
      }
      return [arr1, arr2, arr3]
    },
    // getDetails
    getDetails() {
      this.loading = true
      getStProjectAward({ id: this.$route.query.id }).then(res => {
        this.loading = false
        if (res.code === '000') {
          const { declareVo, detailVo, zsCheckVo, stage, awardsLv, confirm } = res.result
          if (stage < 4) {
            this.activeName = 'first'
          } else if (stage == 4) {
            this.activeName = 'third'
          } else {
            this.activeName = 'fourth'
          }
          this.zsCheckVo = zsCheckVo
          this.detailVo = detailVo
          this.awardsLv = awardsLv
          // 其他完成人和信息
          declareVo.qtList = []
          const alignedArrays = this.alignArrays(declareVo.otherThose || [], declareVo.phones || [], declareVo.otherEmails || [])
          const arr1 = alignedArrays[0]
          const arr2 = alignedArrays[1]
          const arr3 = alignedArrays[2]
          if (arr1.length > 0) {
            arr1.forEach((item, index) => {
              declareVo.qtList.push({ name: arr1[index], phone: arr2[index], email: arr3[index] })
            })
          }
          // console.log(alignedArrays)
          // declareVo.unitName = []
          // if (declareVo.otherThose && declareVo.otherThose.length > 0) {
          //   if (declareVo.otherThose.length > 0 && declareVo.phones.length < 1) {
          //     declareVo.otherThose.forEach(item => {
          //       declareVo.phones.push('')
          //     })
          //   }
          //   const num1 = declareVo.otherThose.length - declareVo.phones.length
          //   const num2 = declareVo.phones.length - declareVo.otherThose.length
          //   if (num1 > 0) {
          //     for (let i = 0; i < num1; i++) {
          //       declareVo.phones.push('')
          //     }
          //   }
          //   if (num2 > 0) {
          //     for (let i = 0; i < num2; i++) {
          //       declareVo.otherThose.push('')
          //     }
          //   }
          //   if (declareVo.otherThose && declareVo.otherThose.length > 0 && declareVo.phones && declareVo.phones.length > 0) {
          //     declareVo.otherThose.forEach((item, index) => {
          //       declareVo.qtList.push({ name: item, phone: declareVo.phones[index] })
          //     })
          //   }
          // }
          // if (declareVo.proveUnits && declareVo.proveUnits.length > 0) {
          //   declareVo.proveUnits.forEach(element => {
          //     declareVo.unitName.push(element.unitName)
          //   })
          //   declareVo.unitName = declareVo.unitName.join('、')
          // }
          this.declareVo = declareVo
          // 授奖信息
          if (confirm && confirm.completePeople) {
            confirm.qtList = []
            confirm.unitList = []
            confirm.completeUnit = confirm.completeUnit.split(',')
            confirm.completePeople = confirm.completePeople.split(',')
            confirm.identityCards = confirm.identityCards ? confirm.identityCards.split(',') : []
            confirm.completePhones = confirm.completePhones ? confirm.completePhones.split(',') : []
            confirm.emails = confirm.emails ? confirm.emails.split(',') : []

            confirm.peopleUnit = confirm.peopleUnit ? confirm.peopleUnit.split(',') : []
            confirm.peoplePosition = confirm.peoplePosition ? confirm.peoplePosition.split(',') : []
            confirm.peopleTitleName = confirm.peopleTitleName ? confirm.peopleTitleName.split(',') : []
            confirm.peopleSchool = confirm.peopleSchool ? confirm.peopleSchool.split(',') : []

            confirm.peopleCodes = confirm.peopleCodes ? confirm.peopleCodes.split(',') : []
            confirm.unitCodes = confirm.unitCodes ? confirm.unitCodes.split(',') : []
            // 完成单位信息
            confirm.completeUnit.forEach((item, index) => {
              confirm.unitList.push({ unit: item, code: confirm.unitCodes[index] })
            })
            // 完成人信息
            confirm.completePeople.forEach((items, index) => {
              confirm.qtList.push({
                name: items,
                phone: confirm.completePhones[index],
                email: confirm.emails[index],
                identity: confirm.identityCards[index],
                unit: confirm.peopleUnit[index] || '',
                job: confirm.peoplePosition[index] || '',
                named: confirm.peopleTitleName[index] || '',
                graduate: confirm.peopleSchool[index] || '',
                code: confirm.peopleCodes[index]
              })
            })
          }
          this.confirm = confirm
          setTimeout(() => {
            if (this.$refs.MyTable1) {
              this.MyTable1Height = this.$refs.MyTable1.offsetHeight
            }
            // console.log(this.$refs.MyTable1)
            // console.log(this.$refs.MyTable1.offsetHeight)
          }, 100)
        }
      })
    },
    dialogShow(title, list, type) {
      this.dialog.dialogVisible = true
      this.dialog.title = title
      this.dialog.type = type
      this.dialog.list = list
    },
    close() {
      this.dialog.dialogVisible = false
      // this.dialog.title = ''
      this.dialog.type = ''
      // this.dialog.list = []
    },
    // 下载模板
    download(status) {
      const name = this.fileList['file' + status].remark
      uploadFileDownload({ path: this.fileList['file' + status].path }).then(res => {
        const blob = new Blob([res.data])
        // const fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('filename=')[1])
        const fileName = name
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    },
    // 下载二维码、资质材料
    ewm(row, index) {
      getQrcodeCheckProject({ id: this.$route.query.id }).then(res => {
        if (res.code === '000') {
          getStProjectEwm({ id: this.$route.query.id }).then(res => {
            const blob = new Blob([res.data])
            const fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('filename=')[1])
            console.log(fileName)
            if ('download' in document.createElement('a')) { // 非IE下载
              const elink = document.createElement('a')
              elink.download = fileName
              elink.style.display = 'none'
              elink.href = URL.createObjectURL(blob)
              document.body.appendChild(elink)
              elink.click()
              URL.revokeObjectURL(elink.href) // 释放URL 对象
              document.body.removeChild(elink)
            } else { // IE10+下载
              navigator.msSaveBlob(blob, fileName)
            }
          })
          // this.download(8)
        }
      })
    },
    // 进入终审补充材料
    replenish(row, index) {
      // this.addForm.id = this.$route.query.id
      // this.addForm.projectId = this.projectId
      // this.addForm.dialogVisible = true
      // this.$router.push({ path: '/project/add2', query: { id: this.$route.query.id, batchId: this.$route.query.batchId } })
      this.$router.push({ path: '/project/add3', query: { id: this.$route.query.id, batchId: this.$route.query.batchId, projectId: this.projectId } })
    },
    submitAdd() {
      this.$refs.addForm.validate(valid => {
        if (!valid) return false
        this.addForm.loading = true
        const parmas = {
          phase: 3,
          projectId: this.addForm.projectId,
          projectAwardId: this.addForm.id,
          fileItems: [
            { type: 1, filePath: this.addForm.projectExcelPath, sort: 1 },
            { type: 2, filePath: this.addForm.declarePdfPath, sort: 2 },
            { type: 3, filePath: this.addForm.projectResultsPath, sort: 3 }
          ]
        }
        addStProjectAwardThree(parmas).then(res => {
          this.addForm.loading = false
          if (res.code === '000') {
            this.$message.success('操作成功')
            this.addForm.dialogVisible = false
            this.getDetails()
          }
        })
      })
    },
    closeAddForm() {
      this.$refs.addForm.resetFields()
      this.addForm.projectExcelFiles = []
      this.addForm.declarePdfFiles = []
      this.addForm.projectResultsFiles = []
    },
    // 上传材料
    replenishs() {
      this.$router.push({ path: '/project/add2', query: { id: this.$route.query.id, batchId: this.$route.query.batchId } })
      // this.materials.id = this.$route.query.id
      // this.materials.dialogVisible = true
    },
    closeMaterials() {
      this.$refs.materials.resetFields()
      this.materials.projectExcelFiles = []
      this.materials.declarePdfFiles = []
      this.materials.projectResultsFiles = []
    },
    submitAdds() {
      this.$refs.materials.validate(valid => {
        if (!valid) return false
        this.materials.loading = true
        const parmas = {
          // projectId: this.materials.projectId,
          phase: 0,
          projectAwardId: this.materials.id,
          fileItems: [
            { type: 4, filePath: this.materials.projectExcelPath, sort: 1 },
            { type: 5, filePath: this.materials.declarePdfPath, sort: 2 },
            { type: 6, filePath: this.materials.projectResultsPath, sort: 3 }
          ]
        }
        addStProjectAwardThree(parmas).then(res => {
          this.materials.loading = false
          if (res.code === '000') {
            this.$message.success('操作成功')
            this.materials.dialogVisible = false
            this.getDetails()
          }
        })
      })
    },
    // 撤回
    handleCh(row, index) {
      this.$confirm('是否确定撤回该申报?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        increasedProjectWithdraw({ id: this.$route.query.id }).then(res => {
          if (res.code == '000') {
            this.$message.success('操作成功')
            this.getDetails()
          }
        })
      }).catch(() => {})
    },
    // 跳转编辑
    handleEdit() {
      this.$router.push({ path: '/project/add1', query: { id: this.$route.query.id, batchId: this.$route.query.batchId } })
    },
    // 下载文件
    handleUploadFinal(path, name) {
      const elink = document.createElement('a')
      elink.download = name
      elink.style.display = 'none'
      elink.href = '/fid/' + path
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    },
    handleUploadAward(path) {
      AdminDownLoadFile({ path }).then(res => {
        const blob = new Blob([res.data])
        const fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('filename=')[1])
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    },
    getStatus() {
      return getMangerStatus().then(res => {
        if (res.code == '000') {
          this.projectState = res.result.projectState
        }
      })
    }
  }
}
</script>

<style lang="less" >

.first-1 {
  .el-descriptions-item__label.is-bordered-label {
    width: 150px;
  }
  .el-descriptions-item__content {
    width: 350px;
  }
  .dan {
    .el-descriptions-item__label.is-bordered-label:nth-child(3) {
      border-left: none !important;
      border-right: none !important;
      background-color: #fff;
    }
    .el-descriptions-item__cell.el-descriptions-item__content:nth-child(2) {
      border-right: none !important;
    }
    .el-descriptions-item__cell.el-descriptions-item__content:nth-child(4) {
      border-left: none !important;
    }
  }
  .first-1-1 {
    .el-descriptions-item__label.is-bordered-label {
      width: 300px;
    }
  }
}
.second-2 {
  .el-descriptions-item__label.is-bordered-label {
    width: 150px;
  }
  // .el-descriptions-item__content {
  //   width: 200px;
  // }
}

</style>
